import React from 'react';

import classNames from "classnames";
import styles from "../../../styles/athlete-widget.placeholder.module.scss";

export const AthleteWidgetRowCompetitorsPlaceholder = () => {
  return (
    <div className={classNames(styles.row_competitors)}>
      <div className={classNames(styles.row_competitor)}/>
      <div className={classNames(styles.row_competitor)}/>
    </div>
  )
};